// extracted by mini-css-extract-plugin
export const root = "exhibition-map-module--root--17NJc";
export const aspectRatioWrapper = "exhibition-map-module--aspectRatioWrapper--1Jb4j";
export const title = "exhibition-map-module--title--3GXDJ";
export const map = "exhibition-map-module--map--1036y";
export const dark = "exhibition-map-module--dark--26o-J";
export const isActive = "exhibition-map-module--isActive--28zTI";
export const light = "exhibition-map-module--light--2s-fz";
export const information = "exhibition-map-module--information--12Igb";
export const text = "exhibition-map-module--text--1RHYo";